module.exports = __webpack_public_path__ + "img/scriptTask.da7e394e.svg";